import { deepCopy } from '@/utils/toolkit/object/copy.utils';
import { Injectable } from '@angular/core';
import { TileMultiSensorsComponent } from '../../../components/tile/tile-multi-sensors/tile-multi-sensors';
import type { SystemDefaultTile } from '../../../interfaces/system-default-tile.interface';
import type { CoreSystemWithSensors } from '../../../interfaces/System.interface';
import type { CustomTileModel, MultiTileDescriptionData, MultiTileModel, MultiTileSensor } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileMultiSensorsProvider implements CustomTileProvider {
    fillTileDescription(
        tileDescription: MultiTileModel,
        defaultTile: SystemDefaultTile<MultiTileDescriptionData>,
        system: CoreSystemWithSensors
    ): CustomTileModel {
        const customTileModel: MultiTileModel = deepCopy(tileDescription);
        customTileModel.sensors = system.sensors
            .filter(s => s.isActive)
            .map(deployedSensor => {
                let defaultSensor: MultiTileSensor<void> = defaultTile.tileParams.sensors.find(
                    s => s.sensorIdentifier.sensorId === deployedSensor.sensorId
                )!;
                if (!defaultSensor) {
                    defaultSensor = defaultTile.tileParams.sensors.find(s => s.universeId === deployedSensor.universeId)!;
                }
                if (!defaultSensor) {
                    return null;
                }
                const tileSensorToCreate: MultiTileSensor<void> = deepCopy(defaultSensor);
                if (!defaultSensor.universeId) {
                    tileSensorToCreate.universeId = deployedSensor.universeId;
                }
                tileSensorToCreate.sensorIdentifier = { systemId: deployedSensor.systemId, sensorId: deployedSensor.sensorId };
                return tileSensorToCreate;
            })
            .filter(x => !!x);
        return customTileModel;
    }

    getTileComponent() {
        return TileMultiSensorsComponent;
    }
}
